/** The warehouse list's title and its create control. */
import { Plus } from 'lucide-react';

export default function WarehouseListHeader({ onCreate }: { onCreate: () => void }) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h2 className="text-xl font-bold text-bark-900 dark:text-stone-100">Warehouses</h2>
        <p className="text-sm text-stone-500 dark:text-stone-400 mt-1">
          Manage supply chain warehouse locations
        </p>
      </div>
      <button
        onClick={onCreate}
        className="flex items-center gap-2 px-4 py-2 bg-moss-600 text-white rounded-lg hover:bg-moss-700 transition"
      >
        <Plus size={18} />
        Create Warehouse
      </button>
    </div>
  );
}
